<template src="./review-beneficiary.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import Vuelidate from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import { mask } from 'vue-the-mask'

Vue.use(Vuelidate)

// const positiveDecimal = (value) => value === null || (!isNaN(Number(value)) && Number(value)) > 0

export default {
  name: 'update-user',
  mixins: [validationMixin],
  directives: {
    mask
  },
  components: {
    ContextPage
  },
  data () {
    return {
      pageLoader: false,
      documentDownloading: false,
      userId: '',
      user: null,
      accountEditMode: false,
      statusEditMode: false,
      UserStatus: {
        PENDING: 1,
        ACTIVE: 2,
        WAITING_ACCOUNT: 3,
        PROCESSED: 4,
        COMPLETED: 5,
        REJECTED: 6,
        ERROR: 7,
        REQUIRES_CONFIRMATION: 101,
        CONFIRMATION_PROVIDED: 102
      },
      UserType: {
        EMPLOYED: 1,
        UNEMPLOYED: 2,
        RETIRED: 3,
        RETIREDCASHPAYMENTS: 4,
        BENEFICIARY: 5,
        OTHER: 6
      },
      status: [
        {
          color: '#CFD8DC',
          dark: false,
          text: this.$t('subsidyUser.subsidyPending')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyActive')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyWaitingAccount')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyProcessed')
        },
        {
          color: '#3d92b6',
          dark: true,
          text: this.$t('subsidyUser.subsidyCompleted')
        },
        {
          color: '#FF5722',
          dark: true,
          text: this.$t('subsidyUser.subsidyRejected')
        },
        {
          color: '#d3454a',
          dark: true,
          text: this.$t('subsidyUser.subsidyError')
        }
      ],
      uniqueIdentificationNumberMask: '#############',
      retrieveUser: {
        uniqueIdentificationNumber: ''
      }
    }
  },
  computed: {
    uniqueIdentificationNumberErrors () {
      return this.getRetrieveValidationErrorsByName('uniqueIdentificationNumber')
    },
    userStatusMessage () {
      return this.formatOperatorUserStatus(this.user, this.UserStatus)
    },
    userRequiresConfirmation () {
      if (!this.user) { return false }

      return this.user.status === this.UserStatus.REQUIRES_CONFIRMATION
    },
    userConfirmationProvided () {
      if (!this.user) { return false }

      return this.user.status === this.UserStatus.CONFIRMATION_PROVIDED
    }
  },
  created () {
    const queryParamUid = this.$route.query.uniqueIdentificationNumber
    if (typeof queryParamUid !== 'undefined' && queryParamUid !== null && typeof queryParamId !== 'undefined') {
      this.retrieveUser.uniqueIdentificationNumber = queryParamUid
      this.submitRetrieval()
    }
  },
  methods: {
    getRetrieveValidationErrorsByName (name) {
      if (!this.$v.retrieveUser[name].$dirty) return []
      return this.getValidationErrors('retrieveUser').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeRetrieve () {
      this.$v.retrieveUser.$touch()
      if (this.$v.retrieveUser.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.submitRetrieval()
    },
    submitRetrieval () {
      this.user = null
      this.pageLoader = true
      this.$http.get(`${Vue.$apiConfig.beneficiaryDataGet}/${this.retrieveUser.uniqueIdentificationNumber}`).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.crearRetrieveData()
          this.pageLoader = false
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.pageLoader = false
        })
    },
    crearRetrieveData () {
      this.retrieveUser.uniqueIdentificationNumber = ''
      this.$v.retrieveUser.$reset()
    }
  },
  validations () {
    const retrieveRules = {}

    Object.assign(retrieveRules, {
      uniqueIdentificationNumber: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13)
      }
    })

    return {
      retrieveUser: retrieveRules
    }
  }
}
</script>

<style scoped>
  .v-card__text {
    font-size: 15px
  }
  .user-info-type {
    font-size: 16px
  }
  .user-info {
    font-size: 16px;
    font-weight: 600
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  .role-popout {
    background-color: #E0F2F1 !important;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .centered-label {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>
